import { Component, OnInit } from '@angular/core';
import { ModalVideoComponent } from '../dialogs/modal-video/modal-video.component'
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  verVideo(){
   
      const dialogRef = 
        this.dialog.open(ModalVideoComponent, {
          disableClose: true ,
          data: {url: 'https://www.youtube.com/embed/18eTGsFISFA'}
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    
  }

}
